import { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { capitalize } from "lodash";

import EditIcon from '@mui/icons-material/EditNote';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import PlusIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import ViewTableIcon from '@mui/icons-material/TableRows';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';

import CreateLeadButton from './CreateLeadButton';
import LeadFilters from './LeadFilters';
import LeadMetrics from './LeadMetrics';
import LeadsTable from './LeadsTable';
import LeadKanban from './LeadKanban';
import LeadStatusTabs from './LeadStatusTabs';
import LoadingScreen from '../common/LoadingScreen';
import useIsMobile from '../../hooks/useIsMobile';

const TableView = props => {
  if (props.isLoading) return <LoadingScreen />;
  return (
    <Box>
      <LeadsTable
        {...props}
        rows={(props.rows || []).map(s => ({ data: s }))}
      />
    </Box>
  );
};

const ListLeadsScreen = props => {
  const {isTableView, setIsTableView, isEditing, setIsEditing} = props;
  const { metrics } = props;
  // const { color, Icon } = getStatusOptions(tabName);
  const isMobile = useIsMobile();
  return (
    <Box className="list-session" marginTop='12px'>
      <Box sx={{display: {'xs': 'none', 'sm': 'none', 'md': 'block', 'lg': 'block'}}}>
        <LeadMetrics filter={props.filter} metrics={metrics} status={props?.filters?.status} />
      </Box>
      <Stack direction={{md:'row', xs:'column'}} gap={1} alignItems='center' justifyContent='space-between'>
        <LeadFilters
          showStatusFilter={isTableView}
          filters={props.filters}
          onFilterChange={props.onFilterChange}
          isAdmin={props.isAdmin}
          isTableView={props.isTableView}
          isEditing={props.isEditing}
        />
        <Box sx={{marginBottom: {xs: '1rem', md: 0}}}>
          <Stack direction='row' spacing={1} alignItems='center' justifyContent={{xs: 'space-between', md: 'flex-end'}}>
            <ButtonGroup>
              <Button size='small' variant={isTableView ? 'contained' : undefined} onClick={() => setIsTableView(true)}>
                <ViewTableIcon />
              </Button>
              <Button size='small' variant={!isTableView ? 'contained' : undefined} onClick={() => setIsTableView(false)}>
                <ViewKanbanIcon/>
              </Button>
            </ButtonGroup>
            {(!!props?.isAdmin || isEditing) && 
              <IconButton 
                size='small' 
                color={isEditing ? 'secondary' : 'primary'}
                onClick={() => setIsEditing(!isEditing)}
              >
                <EditIcon />
              </IconButton>
            }
            <CreateLeadButton size='small' isAdmin={props.isAdmin} />
          </Stack>
        </Box>
      </Stack>
      {isTableView ? <Card className="list-session__card drop-shadow">
        <CardContent>
          {/* <Box>
            <Box sx={{ display: {xs: 'none', md: 'block'}, marginLeft: '0.365rem'}}>
              <LeadStatusTabs {...props} />
            </Box>
          </Box> */}
          {props.isUpdating && !props.isEditing &&
            <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems='center' style={{minHeight: '1.5em'}}>
              <CircularProgress size={20} />
              <Typography variant='body2' color='text.gray'>Refreshing</Typography>
            </Stack>
          }
          <TableView
            isEditing={isEditing}
            isLoading={props.isLoading}
            rows={props?.rows || []}
            pageSize={props?.pageSize}
            pageIndex={props?.pageIndex || 0}
            count={props?.count}
            onPageChange={props.onPageChange}
            afterSave={props?.query?.refetch || null}
            isMobile={isMobile}
            filters={props.filters}
          />
        </CardContent>
      </Card>
      : <LeadKanban 
          filters={props.filters}
          isAdmin={props.isAdmin}
        />
      }
    </Box>
  );
};

ListLeadsScreen.propTypes = {
  filters: PropTypes.object,
  tab: PropTypes.string,
  counts: PropTypes.object,
};

export default ListLeadsScreen;
